import React, { useState } from "react";
import { motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export default function FAQSection({ faqs }) {
  const [open, setOpen] = useState(faqs[0]?.id || null);

  return (
    <section id="faq" className="section bg-white border-y border-[#E4E1D9]">
      <div className="container-z grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="label-mono mb-3">FAQ</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1A231E]">
            Quick answers
          </h2>
          <p className="mt-4 text-[#5C6B62] text-base max-w-sm">
            Everything you need to know before downloading. Got more questions?{" "}
            <a href="#contact" className="text-[#C86646] font-semibold hover:underline">
              Ask us directly
            </a>
            .
          </p>
        </div>
        <div className="lg:col-span-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === f.id;
            return (
              <motion.div
                key={f.id}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.04 }}
                className="zcard !shadow-none border border-[#E4E1D9] hover:!shadow-none hover:!translate-y-0"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : f.id)}
                  className="w-full p-5 sm:p-6 flex items-center gap-4 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="flex-1 font-semibold text-base sm:text-lg text-[#1A231E]">
                    {f.question}
                  </span>
                  <span
                    className={`w-9 h-9 flex-shrink-0 rounded-full flex items-center justify-center transition-colors ${
                      isOpen ? "bg-[#C86646] text-white" : "bg-[#F7F6F2] text-[#1A231E]"
                    }`}
                  >
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 sm:px-6 pb-6 text-sm sm:text-base text-[#5C6B62] leading-relaxed">
                    {f.answer}
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
